/** Shared My Stores cue. No identity, preferences or exposure state is persisted. */
export const STORE_GLOW_DURATION_MS = 4_800;
export const STORE_GLOW_TARGET_COUNT = 3;

export function createStoreButtonGlow(options: {
  preferencesReady: boolean;
  now?: () => number;
}) {
  const now = options.now ?? (() => performance.now());
  let preferencesReady = options.preferencesReady;
  let acknowledged = false;
  let startedAt: number | null = null;
  return {
    setPreferencesReady(value: boolean): void { preferencesReady = value; },
    // Interaction stops motion, not the reminder to finish choosing stores.
    acknowledge(): void { acknowledged = true; },
    beginVisit(): void { acknowledged = false; startedAt = null; },
    view(stores: readonly string[]): { animate: boolean; elapsedMs: number } | null {
      // Wait for the existing cloud sync before deciding from saved preferences.
      if (!preferencesReady) return null;
      const count = new Set(stores.map(store => store.trim()).filter(Boolean)).size;
      if (count >= STORE_GLOW_TARGET_COUNT) return null;
      const time = now();
      startedAt ??= time;
      const elapsedMs = acknowledged ? STORE_GLOW_DURATION_MS : Math.max(0, time - startedAt);
      return { animate: elapsedMs < STORE_GLOW_DURATION_MS,
        elapsedMs: Math.min(elapsedMs, STORE_GLOW_DURATION_MS) };
    },
  };
}
